import {
  CLUBE,
  CLUBE_PARCERIAS,
  MEDICAL_PARTNER,
  POSTHUMOUS,
  TELEVET,
} from '../../../routes';

export interface Benefit {
  id: string;
  title: string;
  description: string;
  image: string;
  buttonText: string;
  buttonUrl: string;
  categories?: { label: string; url: string }[];
}

export const BENEFITS: Benefit[] = [
  {
    id: 'health',
    title: 'Cuidados e Saúde',
    description:
      'Possuímos os melhores planos de saúde para você e sua família',
    image: 'hub_section_benefits_health.png',
    buttonText: 'Saiba Mais',
    buttonUrl: MEDICAL_PARTNER,
  },
  {
    id: 'club',
    title: 'Clube de Vantagens',
    description:
      'Aproveite descontos em alimentação, lazer e serviços na sua região',
    image: 'hub_section_benefits_club.png',
    buttonText: 'Saiba Mais',
    buttonUrl: `${CLUBE}/home`,
    categories: [
      { label: 'Desconto em cinemas', url: `${CLUBE_PARCERIAS}/cinema` },
    ],
  },
  {
    id: 'pet',
    title: 'Para seu Pet',
    description:
      'Descontos e serviços exclusivos para cuidar do bem-estar dos seus pets',
    image: 'hub_section_benefits_pet.png',
    buttonText: 'Saiba Mais',
    buttonUrl: `${TELEVET}/home`,
  },
  {
    id: 'posthumous',
    title: 'Serviços Póstumos',
    description:
      'Oferecemos apoio completo, garantindo tranquilidade para sua família',
    image: 'hub_section_benefits.png',
    buttonText: 'Saiba Mais',
    buttonUrl: POSTHUMOUS,
  },
];
